var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M10.73,7.5h.063a.375.375,0,0,1,.373.338l.341,3.412,2.436,1.392a.375.375,0,0,1,.189.326v.157a.286.286,0,0,1-.362.276l-3.464-.945a.375.375,0,0,1-.275-.391l.325-4.22A.375.375,0,0,1,10.73,7.5Z",
    transform: "translate(-2.508 -1.875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    opacity: 0.3,
    d: "M5.792,2.436a7.865,7.865,0,1,1-4.5,5.117l1.444.405A6.367,6.367,0,1,0,6.812,3.651L7.7,4.715a.375.375,0,0,1-.266.615l-3.65.207A.375.375,0,0,1,3.4,5.076l.846-3.548A.375.375,0,0,1,4.9,1.374Z",
    transform: "translate(-0.25 -0.31)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7f052f6996c5658e92cb6a471c91c546.svg";
export { ForwardRef as ReactComponent };